import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { type OfferRow, api } from "../lib/api";

type OffersResp = { items: OfferRow[]; total: number; scope: "own" | "public" };

export function Offers() {
	const nav = useNavigate();
	const { data, isLoading, error } = useQuery<OffersResp>({
		queryKey: ["offers"],
		queryFn: () => api.get("/offers"),
	});

	if (isLoading) return <div className="p-6">Loading…</div>;
	if (error) return <div className="p-6 text-red-700">Error: {(error as Error).message}</div>;
	const items = data?.items ?? [];

	return (
		<div className="p-6">
			<div className="mb-4 flex items-center justify-between">
				<h1 className="text-xl font-semibold">
					Offers ({data?.scope === "own" ? "yours" : "public"})
				</h1>
				{data?.scope === "own" && (
					<button
						type="button"
						className="rounded bg-blue-600 px-3 py-1 text-sm text-white hover:bg-blue-700"
						onClick={() => nav("/offers/new")}
					>
						+ New offer
					</button>
				)}
			</div>
			<table className="w-full text-sm">
				<thead className="text-left text-neutral-500">
					<tr>
						<th className="py-1">Title</th>
						<th>Vertical</th>
						<th>Payout</th>
						<th>Geos</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{items.map((o) => (
						<tr key={o.id} className="border-t border-neutral-200 hover:bg-neutral-50">
							<td className="py-1">
								<Link to={`/offers/${o.id}`} className="text-blue-700 hover:underline">
									{o.title}
								</Link>
							</td>
							<td>{o.vertical}</td>
							<td>
								{o.payoutType} {o.payoutAmount ?? `${o.payoutPercent}%`} {o.payoutCurrency}
							</td>
							<td>{safeArr(o.geos).join(", ")}</td>
							<td>{o.status}</td>
						</tr>
					))}
					{items.length === 0 && (
						<tr>
							<td colSpan={5} className="py-4 text-center text-neutral-500">
								No offers yet.
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
}

function safeArr(s: string | null): string[] {
	if (!s) return [];
	try {
		const v = JSON.parse(s);
		return Array.isArray(v) ? (v as string[]) : [];
	} catch {
		return [];
	}
}
